<template>
  <div class="human-capitalt-view-past">
    <h2 class="heading-lv2">{{this.elderlyRate.year}}年{{this.month}}月期</h2>
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">年齢構成</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col>
            <col style="width: 90px;">
            <col>
            <col style="width: 90px;">
          </colgroup>
          <tbody>
            <tr>
              <th class="u-tar">〜44歳</th>
              <td><span class="human-capitalt-data-table__text"><Currency :value="elderlyRate.ageRange1Count" :unit="this.unit"/></span></td>
              <th class="u-tar">60〜64歳</th>
              <td><span class="human-capitalt-data-table__text"><Currency :value="elderlyRate.ageRange5Count" :unit="this.unit"/></span></td>
            </tr>
            <tr>
              <th class="u-tar">45〜49歳</th>
              <td><span class="human-capitalt-data-table__text"><Currency :value="elderlyRate.ageRange2Count" :unit="this.unit"/></span></td>
              <th class="u-tar">65〜69歳</th>
              <td><span class="human-capitalt-data-table__text"><Currency :value="elderlyRate.ageRange6Count" :unit="this.unit"/></span></td>
            </tr>
            <tr>
              <th class="u-tar">50〜54歳</th>
              <td><span class="human-capitalt-data-table__text"><Currency :value="elderlyRate.ageRange3Count" :unit="this.unit"/></span></td>
              <th class="u-tar">70歳〜</th>
              <td><span class="human-capitalt-data-table__text"><Currency :value="elderlyRate.ageRange7Count" :unit="this.unit"/></span></td>
            </tr>
            <tr>
              <th class="u-tar">55〜59歳</th>
              <td><span class="human-capitalt-data-table__text"><Currency :value="elderlyRate.ageRange4Count" :unit="this.unit"/></span></td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->

      <div class="human-capitalt-data-wrap__space"></div>

      <div class="human-capitalt-data-wrap__results">
        <div class="human-capitalt-data-results">
          <div class="human-capitalt-data-results__text">
            高年齢者雇用率
            <strong><Currency :value="elderlyRate.achievementElderlyRate"/></strong>%
          </div>
        </div>
      </div>

    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
            <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(elderlyRate.resultMemo)"></p>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
            </div>
            <div class="l-contentsMemo__body">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(elderlyRate.actionMemo)"></p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2 u-mt30-->
  </div><!--/human-capitalt-data-past-->

</template>

<script>
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    Currency,
  },
  props: {
    // 表示年度の財務情報データ
    elderlyRate: {},
    month: null,
    num: null,
  },
  data() {
    return {
      unit: '名',
      unit2:'％',
    }
  },
  computed: {
    sumOfAll() {
      if ( !(this.elderlyRate.ageRange1Count!=null && this.elderlyRate.ageRange2Count!=null && this.elderlyRate.ageRange3Count!=null && this.elderlyRate.ageRange4Count!=null && this.elderlyRate.ageRange5Count!=null && this.elderlyRate.ageRange6Count!=null && this.elderlyRate.ageRange7Count!=null) ) {
        return null;
      }else if ( String(this.elderlyRate.ageRange1Count).length * String(this.elderlyRate.ageRange2Count).length * String(this.elderlyRate.ageRange3Count).length * String(this.elderlyRate.ageRange4Count).length * String(this.elderlyRate.ageRange5Count).length * String(this.elderlyRate.ageRange6Count).length * String(this.elderlyRate.ageRange7Count).length == 0 ) {
        return null;
      }else if ( isNaN(this.elderlyRate.ageRange1Count) || isNaN(this.elderlyRate.ageRange2Count) || isNaN(this.elderlyRate.ageRange3Count) || isNaN(this.elderlyRate.ageRange4Count) || isNaN(this.elderlyRate.ageRange5Count) || isNaN(this.elderlyRate.ageRange6Count) || isNaN(this.elderlyRate.ageRange7Count)) {
        return null;
      }else{
        return Number(this.elderlyRate.ageRange1Count) + Number(this.elderlyRate.ageRange2Count) + Number(this.elderlyRate.ageRange3Count) + Number(this.elderlyRate.ageRange4Count) + Number(this.elderlyRate.ageRange5Count) + Number(this.elderlyRate.ageRange6Count) + Number(this.elderlyRate.ageRange7Count);
      }
    },
    sumOfElderly() {
      if ( !( this.elderlyRate.ageRange4Count!=null && this.elderlyRate.ageRange5Count!=null && this.elderlyRate.ageRange6Count!=null && this.elderlyRate.ageRange7Count!=null ) ) {
        return null;
      }else if ( String(this.elderlyRate.ageRange4Count).length * String(this.elderlyRate.ageRange5Count).length * String(this.elderlyRate.ageRange6Count).length * String(this.elderlyRate.ageRange7Count).length == 0 ) {
        return null;
      }else if ( isNaN(this.elderlyRate.ageRange4Count) || isNaN(this.elderlyRate.ageRange5Count) || isNaN(this.elderlyRate.ageRange6Count) || isNaN(this.elderlyRate.ageRange7Count)) {
        return null;
      }else{
        return Number(this.elderlyRate.ageRange4Count) + Number(this.elderlyRate.ageRange5Count) + Number(this.elderlyRate.ageRange6Count) + Number(this.elderlyRate.ageRange7Count);
      }
    },
    calAchievementElderlyRate() {
      if ( this.sumOfAll != null && this.sumOfElderly != null ){
        if(this.sumOfAll == 0) return null;
        if(this.sumOfElderly == 0) return 0;
        let val = (this.sumOfElderly / this.sumOfAll) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }else{
        return null;
      }
    }
  },
  watch: {
    elderlyRate() {
      this.inputElderlyRate();
    },
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputElderlyRate() {
      this.$emit("change-elderly-rate-detail", {
        elderlyRate: this.elderlyRate,
        month: this.month,
        num: this.num,
      });
    },
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },

  }
}

</script>
